module.exports = __webpack_public_path__ + "fonts/Lexend-SemiBold.9d307b5.woff2";